import type { GeomTypeUtil } from "./geomTypeUtil";
import type BoundsUtil from "../../boundsUtil";
import type MatrixUtil from "../../matrixUtil";
import type GeomUtil from "../geomUtil";

export default class LS implements GeomTypeUtil {
    private readonly boundsUtil: BoundsUtil;
    private readonly geomUtil: GeomUtil;
    private readonly matrixUtil: MatrixUtil;

    constructor(boundsUtil: BoundsUtil, geomUtil: GeomUtil, matrixUtil: MatrixUtil) {
        this.boundsUtil = boundsUtil;
        this.geomUtil = geomUtil;
        this.matrixUtil = matrixUtil;
    }

    extractPoints(geom: any[], callback: Function, owner?: any) {
        for(let g = geom.length - 2; g >= 1; g -= 2){
            callback.call(owner, geom, g);
        }
    }
    
    extractLines(geom: any[], callback: Function, owner?: any) {
        callback.call(owner, geom, 1, geom.length);
    }
    
    getBounds(geom: any[], bounds: number[]): number[] {
        return this.boundsUtil.valueOf(geom, bounds, 1);
    }
    
    transform(geom: any[], matrix: any[]): any[] {
        return this.matrixUtil.transform(matrix, geom, 1, geom.length, ["LS"]);
    }
    
    generalize(geom: any[], threshold: number): any[] {
        return this.geomUtil.generalizeLines(geom, 1, geom.length, threshold, ["LS"]);
    }

    extractMidPoints(geom: any[], callback: Function, owner?: any) {
        this.extractLines(geom, function(array: number[], startIndex: number, endIndex: number, ringIndex: number) {
            while (startIndex < endIndex - 2) { // last point is the same as the first point in polygon
                const midPointStartIndex = startIndex;
                const x1 = array[startIndex++];
                const y1 = array[startIndex++];
                const x2 = array[startIndex];
                const y2 = array[startIndex + 1];
                const midPoint = [(x1 + x2) / 2, (y1 + y2) / 2];

                callback.call(owner, midPoint, midPointStartIndex, ringIndex);
            }
        });
    }
}
